import React, { useEffect, useState } from "react";
import Conexao from '../../Config/conexao';
import axios from 'axios';
import moment from 'moment';
import Navbar from '../NavbarSondagem/navbarSondagem';
import { CheckBox } from "@mui/icons-material";

import saveAs from "file-saver";




import { excel } from "react-export-table-to-excel/lib/lib";
import { TryRounded } from "@mui/icons-material";
import SweetAlert from 'react-bootstrap-sweetalert';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';



export default function Piezometro() {


    const [mesEAno, setMesEAno] = useState();
    const [equipamento, setEquipamento] = useState('');

    const [listaDados, setListaDados] = useState([]);
    const [listaDados2, setListaDados2] = useState([]);
    const [listaDados3, setListaDados3] = useState([]);


    const [abrirDia1, setAbrirDia1] = useState(false);





    const [processo, setProcesso] = useState("")
    const [idInstrumento, setIdInstrumento] = useState()
    const [profInstalacao, setInstalacao] = useState()
    const [createcnico, setCreatecnico] = useState()
    const [profFinal, setProfFinal] = useState()
    const [inclinacao, setInclinacao] = useState()
    const [sistema, setSistema] = useState()
    const [coordenadaE, setCoordenadaE] = useState()
    const [coordenadaN, serCoordenadaN] = useState()
    const [cota, setCota] = useState()
    const [sondador, setSondador] = useState()
    const [tecnico, setTecnico] = useState()
    const [observacao, setObservacao] = useState()
    const [dataInicio, setDataInicio] = useState(Date)
    const [dataFim, setDataFim] = useState(Date)












    const [rebaixamento0, setRebaixamento0] = useState()
    const [rebaixamento1, setRebaixamento1] = useState()
    const [rebaixamento2, setRebaixamento2] = useState()
    const [rebaixamento3, setRebaixamento3] = useState()
    const [rebaixamento4, setRebaixamento4] = useState()
    const [rebaixamento5, setRebaixamento5] = useState()
    const [rebaixamento6, setRebaixamento6] = useState()
    const [rebaixamento7, setRebaixamento7] = useState()
    const [rebaixamento8, setRebaixamento8] = useState()
    const [rebaixamento9, setRebaixamento9] = useState()
    const [rebaixamento10, setRebaixamento10] = useState()
    const [rebaixamento11, setRebaixamento11] = useState()
    const [rebaixamento12, setRebaixamento12] = useState()
    const [rebaixamento13, setRebaixamento13] = useState()
    const [rebaixamento14, setRebaixamento14] = useState()
    const [rebaixamento15, setRebaixamento15] = useState()
    const [rebaixamento16, setRebaixamento16] = useState()
    const [rebaixamento17, setRebaixamento17] = useState()
    const [rebaixamento18, setRebaixamento18] = useState()
    const [rebaixamento19, setRebaixamento19] = useState()
    const [rebaixamento20, setRebaixamento20] = useState()
    const [rebaixamento21, setRebaixamento21] = useState()
    const [rebaixamento22, setRebaixamento22] = useState()
    const [rebaixamento23, setRebaixamento23] = useState()
    const [rebaixamento24, setRebaixamento24] = useState()
    const [rebaixamento25, setRebaixamento25] = useState()
    const [rebaixamento26, setRebaixamento26] = useState()
    const [rebaixamento27, setRebaixamento27] = useState()
    const [rebaixamento28, setRebaixamento28] = useState()
    const [rebaixamento29, setRebaixamento29] = useState()
    const [rebaixamento30, setRebaixamento30] = useState()
    const [rebaixamento31, setRebaixamento31] = useState()
    const [rebaixamento32, setRebaixamento32] = useState()
    const [rebaixamento33, setRebaixamento33] = useState()
    const [rebaixamento34, setRebaixamento34] = useState()
    const [rebaixamento35, setRebaixamento35] = useState()
    const [rebaixamento36, setRebaixamento36] = useState()
    const [rebaixamento37, setRebaixamento37] = useState()
    const [rebaixamento38, setRebaixamento38] = useState()
    const [rebaixamento39, setRebaixamento39] = useState()
    const [rebaixamento40, setRebaixamento40] = useState()



    const [tempo0, setTempo0] = useState();
    const [tempo1, setTempo1] = useState();
    const [tempo2, setTempo2] = useState();
    const [tempo3, setTempo3] = useState();
    const [tempo4, setTempo4] = useState();
    const [tempo5, setTempo5] = useState();
    const [tempo6, setTempo6] = useState();
    const [tempo7, setTempo7] = useState();
    const [tempo8, setTempo8] = useState();
    const [tempo9, setTempo9] = useState();
    const [tempo10, setTempo10] = useState();
    const [tempo11, setTempo11] = useState();
    const [tempo12, setTempo12] = useState();
    const [tempo13, setTempo13] = useState();
    const [tempo14, setTempo14] = useState();
    const [tempo15, setTempo15] = useState();
    const [tempo16, setTempo16] = useState();
    const [tempo17, setTempo17] = useState();
    const [tempo18, setTempo18] = useState();
    const [tempo19, setTempo19] = useState();
    const [tempo20, setTempo20] = useState();
    const [tempo21, setTempo21] = useState();
    const [tempo22, setTempo22] = useState();
    const [tempo23, setTempo23] = useState();
    const [tempo24, setTempo24] = useState();
    const [tempo25, setTempo25] = useState();
    const [tempo26, setTempo26] = useState();
    const [tempo27, setTempo27] = useState();
    const [tempo28, setTempo28] = useState();
    const [tempo29, setTempo29] = useState();
    const [tempo30, setTempo30] = useState();
    const [tempo31, setTempo31] = useState();
    const [tempo32, setTempo32] = useState();
    const [tempo33, setTempo33] = useState();
    const [tempo34, setTempo34] = useState();
    const [tempo35, setTempo35] = useState();
    const [tempo36, setTempo36] = useState();
    const [tempo37, setTempo37] = useState();
    const [tempo38, setTempo38] = useState();
    const [tempo39, setTempo39] = useState();
    const [tempo40, setTempo40] = useState();

    const [leitura0, setLeitura0] = useState();
    const [leitura1, setLeitura1] = useState();
    const [leitura2, setLeitura2] = useState();
    const [leitura3, setLeitura3] = useState();
    const [leitura4, setLeitura4] = useState();
    const [leitura5, setLeitura5] = useState();
    const [leitura6, setLeitura6] = useState();
    const [leitura7, setLeitura7] = useState();
    const [leitura8, setLeitura8] = useState();
    const [leitura9, setLeitura9] = useState();
    const [leitura10, setLeitura10] = useState();
    const [leitura11, setLeitura11] = useState();
    const [leitura12, setLeitura12] = useState();
    const [leitura13, setLeitura13] = useState();
    const [leitura14, setLeitura14] = useState();
    const [leitura15, setLeitura15] = useState();
    const [leitura16, setLeitura16] = useState();
    const [leitura17, setLeitura17] = useState();
    const [leitura18, setLeitura18] = useState();
    const [leitura19, setLeitura19] = useState();


    const [bloqueio, setBloqueio] = useState(true);






    const [habilitar, setHabilitar] = useState(false)
    const [bnthabilitar, setBnthabilitar] = useState("true")



    function Bloquear() { setBloqueio(false) };

    const bloqueado = bloqueio !== true;

    function Confirmacao() { alert("Salvo com sucesso!") };

    async function add() {
        const obj = {
            processo, idInstrumento, dataInicio, dataFim, profInstalacao, createcnico, profFinal,  inclinacao, sistema, coordenadaE, coordenadaN, cota, sondador, tecnico, observacao, rebaixamento0, rebaixamento1, rebaixamento2, rebaixamento3, rebaixamento4, rebaixamento5, rebaixamento6, rebaixamento7, rebaixamento8, rebaixamento9, rebaixamento10, rebaixamento11, rebaixamento12, rebaixamento13, rebaixamento14, rebaixamento15, rebaixamento16, rebaixamento17, rebaixamento18, rebaixamento19, rebaixamento20, rebaixamento21, rebaixamento22, rebaixamento23, rebaixamento24, rebaixamento25, rebaixamento26, rebaixamento27, rebaixamento28, rebaixamento29, rebaixamento30, rebaixamento31, rebaixamento32 , rebaixamento33 , rebaixamento34 , rebaixamento35 , rebaixamento36 , rebaixamento37 , rebaixamento38 , rebaixamento39 , rebaixamento40
        };

        if (processo !== "" ) {
            const res = await axios.post(Conexao.api + 'SalvarPiezometro.php', obj);
            if (res.data.success === true) {
                Confirmacao();
            } else {
                // Tratar outro caso, se necessário
            }
        } else {
            msg();
        }
    }


    function msg() {
        alert("Por favor, preencha todos os campos obrigatórios.");
    }





    //InserteCheckFadiga

    function Limpar() {

        setMesEAno('');
        setEquipamento('');

    };

    function Limpar2() {

        // setMesEAno('');
        setEquipamento('');

    };




 async function Buscar() {
        
        const res = await axios.get(Conexao.api + 'BuscarPiezometro.php?processo=' + processo);


        if (res.data.success === true) {


            
            setIdInstrumento(res.data.result[0].idInstrumento)
            setInstalacao(res.data.result[0].profInstalacao)
            setCreatecnico(res.data.result[0].createcnico)
            setProfFinal(res.data.result[0].profFinal)
            setInclinacao(res.data.result[0].inclinacao)
            setSistema(res.data.result[0].sistema)
            setCoordenadaE(res.data.result[0].coordenadaE)
            serCoordenadaN(res.data.result[0].coordenadaN)
            setCota(res.data.result[0].cota)
            setSondador(res.data.result[0].sondador)
            setTecnico(res.data.result[0].tecnico)
            setCreatecnico(res.data.result[0].createcnico)
            setObservacao(res.data.result[0].observacao)
            setDataInicio(res.data.result[0].dataInicio)
            setDataFim(res.data.result[0].dataFim)
           
           
 setRebaixamento0(res.data.result[0].rebaixamento0)
 setRebaixamento1(res.data.result[0].rebaixamento1)
 setRebaixamento2(res.data.result[0].rebaixamento2)
 setRebaixamento3(res.data.result[0].rebaixamento3)
 setRebaixamento4(res.data.result[0].rebaixamento4)
 setRebaixamento5(res.data.result[0].rebaixamento5)
 setRebaixamento6(res.data.result[0].rebaixamento6)
 setRebaixamento7(res.data.result[0].rebaixamento7)
 setRebaixamento8(res.data.result[0].rebaixamento8)
 setRebaixamento9(res.data.result[0].rebaixamento9)
 setRebaixamento10(res.data.result[0].rebaixamento10)
 setRebaixamento11(res.data.result[0].rebaixamento11)
 setRebaixamento12(res.data.result[0].rebaixamento12)
 setRebaixamento13(res.data.result[0].rebaixamento13)
 setRebaixamento14(res.data.result[0].rebaixamento14)
 setRebaixamento15(res.data.result[0].rebaixamento15)
 setRebaixamento16(res.data.result[0].rebaixamento16)
 setRebaixamento17(res.data.result[0].rebaixamento17)
 setRebaixamento18(res.data.result[0].rebaixamento18)
 setRebaixamento19(res.data.result[0].rebaixamento19)
 setRebaixamento20(res.data.result[0].rebaixamento20)
 setRebaixamento21(res.data.result[0].rebaixamento21)
 setRebaixamento22(res.data.result[0].rebaixamento22)
 setRebaixamento23(res.data.result[0].rebaixamento23)
 setRebaixamento24(res.data.result[0].rebaixamento24)
 setRebaixamento25(res.data.result[0].rebaixamento25)
 setRebaixamento26(res.data.result[0].rebaixamento26)

 setRebaixamento27(res.data.result[0].rebaixamento27)
 setRebaixamento28(res.data.result[0].rebaixamento28)
 setRebaixamento29(res.data.result[0].rebaixamento29)
 setRebaixamento30(res.data.result[0].rebaixamento30)
 setRebaixamento31(res.data.result[0].rebaixamento31)
 setRebaixamento32(res.data.result[0].rebaixamento32)
 setRebaixamento33(res.data.result[0].rebaixamento33)
 setRebaixamento34(res.data.result[0].rebaixamento34)
 setRebaixamento35(res.data.result[0].rebaixamento35)
 setRebaixamento36(res.data.result[0].rebaixamento36)
 setRebaixamento37(res.data.result[0].rebaixamento37)
 setRebaixamento38(res.data.result[0].rebaixamento38)

 setRebaixamento39(res.data.result[0].rebaixamento39)
 setRebaixamento40(res.data.result[0].rebaixamento40)
 

         

        } else {

           
        
            

            alert(' NÃO REALIZADO')
        }
        console.log('')

      


    };

    






    return <body>

        <Navbar />

        <br />
        <div className='titulolaboratorio container-fluid '>
            <h1 className='texttitulo'>PIEZÔMETRO </h1>
        </div>
        <br />





        <body class="container text-center ">

            <div class="container text-center ">
                <div class="row d-flex align-items-end justify-content-center p-2">

                    <div class="col-md-3 md-0">

                        <h6>PROCESSO:</h6>
                        <input name='processo' id='processo' className='form-control text-center' value={processo} onChange={(e) => setProcesso(e.target.value)} ></input>

                        <div class="col-4">
                            <div className="btn btn-outline-success-center " type="submit"><button onClick={(e) => Buscar(e)} class="btnlogin me-md-2" > Buscar</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </body>


        <form className="container-fluid ">
            <br />
            <br />

            <body  >
                <div class="container text-center">
                    <div class="row d-flex align-items-end justify-content-center p-2">

                        <br />


                        <div class="col-4">
                            <h7>ID do instrumento:</h7>
                            <input name='idInstrumento' id='idInstrumento' className='form-control text-center colorInput ' disabled={habilitar} value={idInstrumento} onChange={(e) => setIdInstrumento(e.target.value)} ></input>
                        </div>


                    </div>
                </div>
            </body>
            <br />



            {/* <body  >
                <div class="container text-center">
                    <div class="row align-items-start">



                        <div class="col-6">
                            <h7>Razão Social:</h7>
                            <input name='empresa' id='empresa' className='form-control text-center colorInput ' disabled={habilitar} value={empresa} onChange={(e) => setEmpresa(e.target.value)} ></input>
                        </div>

                        <div class="col-6">
                            <h7>CONTRATO Nº:</h7>
                            <input name='numeroContrato' id='numeroContrato' className='form-control text-center colorInput ' disabled={habilitar} value={numeroContrato} onChange={(e) => setNumeroContrato(e.target.value)} ></input>
                        </div>

                    </div>
                </div>
            </body> */}
            <body  >
                <div class="container text-center">
                    <div class="row align-items-start">



                        <div class="col">
                            <h7>Data de ínicio:</h7>
                            <input name='dataInicio' id='dataInicio' type='date' className='form-control text-center colorInput ' disabled={habilitar} format='YYYY/MM/DD' value={dataInicio} onChange={(e) => setDataInicio(e.target.value)} ></input>
                        </div>


                        <div class="col">
                            <h7>Data de Fim:</h7>
                            <input name='dataFim' id='dataFim' type='date' className='form-control text-center colorInput ' disabled={habilitar} format='YYYY/MM/DD' value={dataFim} onChange={(e) => setDataFim(e.target.value)} ></input>
                        </div>



                    </div>
                </div>
            </body>
            <br />

            <body  >
                <div class="container text-center">
                    <div class="row align-items-start">


                        <div class="col-6">
                            <h7>Prof. de instalação(m):</h7>
                            <input name='profInstalacao' id='profInstalacao' className='form-control text-center colorInput ' disabled={habilitar} value={profInstalacao} onChange={(e) => setInstalacao(e.target.value)} ></input>
                        </div>

                        <div class="col-6">
                            <h7>CREA Resp. Técnico:</h7>
                            <input name='createcnico' id='createcnico' className='form-control text-center colorInput ' disabled={habilitar} value={createcnico} onChange={(e) => setCreatecnico(e.target.value)} ></input>
                        </div>


                    </div>
                </div>
            </body>

            <br />

            <body  >
                <div class="container text-center">
                    <div class="row align-items-start">




                        <div class="col">
                            <h7>Prof.Final (m)</h7>
                            <input name='profFinal' id='profFinal' className='form-control text-center colorInput ' disabled={habilitar} value={profFinal} onChange={(e) => setProfFinal(e.target.value)} ></input>
                        </div>


                        <div class="col">
                            <h7>Inclinação:</h7>
                            <input name='inclinação' id='inclinação' className='form-control text-center colorInput ' disabled={habilitar} value={inclinacao} onChange={(e) => setInclinacao(e.target.value)} ></input>
                        </div>



                    </div>
                </div>
            </body>

            <br />
            <br />
            <body  >
                <div class="container text-center">
                    <div class="row align-items-start">


                        <h6>Coordendas:</h6>
                        <br />


                        <div class="col">
                            <h7>E=</h7>
                            <input name='coordenadaE' id='coordenadaE' className='form-control text-center colorInput ' disabled={habilitar} value={coordenadaE} onChange={(e) => setCoordenadaE(e.target.value)} ></input>
                        </div>

                        <div class="col">
                            <h7>N=</h7>
                            <input name='coordenadaN' id='coordenadaN' className='form-control text-center colorInput ' disabled={habilitar} value={coordenadaN} onChange={(e) => serCoordenadaN(e.target.value)} ></input>
                        </div>

                    </div>
                </div>
            </body>
            <br />



            <body  >
                <div class="container text-center">
                    <div class="row align-items-start">


                        <br />
                        <div class="col">
                            <h7>Sistema:</h7>
                            <input name='sistema' id='sistema' className='form-control text-center colorInput ' disabled={habilitar} value={sistema} onChange={(e) => setSistema(e.target.value)} ></input>
                        </div>

                        <div class="col">
                            <h7>Cota Base:</h7>
                            <input name='cota' id='cota' className='form-control text-center colorInput ' disabled={habilitar} value={cota} onChange={(e) => setCota(e.target.value)} ></input>
                        </div>

                        <div class="col">
                            <h7>Sondador:</h7>
                            <input name='sondador' id='sondador' className='form-control text-center colorInput ' disabled={habilitar} value={sondador} onChange={(e) => setSondador(e.target.value)} ></input>
                        </div>
                        <div class="col">
                            <h7>Técnico:</h7>
                            <input name='tecnico' id='tecnico' className='form-control text-center colorInput ' disabled={habilitar} value={tecnico} onChange={(e) => setTecnico(e.target.value)} ></input>
                        </div>

                    </div>
                </div>
            </body>


            <br /><br /><br />
            <div class="container text-center">

                <h6>TESTE DE VIDA E FUNCIONAMENTO DO INSTRUMENTO</h6>
                <br />

            </div>



        </form>





        <body className='container text-center d-flex mt-5'>

            <div class="col  align-items-center justify-content-center  ">
                <div class="row d-flex align-items-center justify-content-center ">

                    <div className=' w-25 col-1 text-center'>
                        <h6> Tempo (Minutos)</h6>
                        <input disabled={bloqueado} onChange={(e) => setTempo1(e.target.value)} value={0} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo2(e.target.value)} value={1} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo3(e.target.value)} value={2} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo4(e.target.value)} value={4} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo5(e.target.value)} value={6} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo6(e.target.value)} value={8} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo7(e.target.value)} value={10} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo8(e.target.value)} value={12} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo9(e.target.value)} value={14} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo10(e.target.value)} value={16} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo11(e.target.value)} value={18} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo12(e.target.value)} value={20} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo13(e.target.value)} value={25} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo14(e.target.value)} value={30} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo15(e.target.value)} value={35} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo16(e.target.value)} value={40} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo17(e.target.value)} value={45} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo18(e.target.value)} value={50} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo19(e.target.value)} value={55} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo20(e.target.value)} value={60} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo21(e.target.value)} value={70} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo22(e.target.value)} value={80} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo23(e.target.value)} value={90} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo24(e.target.value)} value={100} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo25(e.target.value)} value={110} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo26(e.target.value)} value={120} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo27(e.target.value)} value={150} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo28(e.target.value)} value={180} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo29(e.target.value)} value={210} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo30(e.target.value)} value={240} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo31(e.target.value)} value={300} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo32(e.target.value)} value={360} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo33(e.target.value)} value={420} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo34(e.target.value)} value={480} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo35(e.target.value)} value={720} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo36(e.target.value)} value={960} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo37(e.target.value)} value={1200} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo38(e.target.value)} value={1280} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo39(e.target.value)} value={1360} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setTempo40(e.target.value)} value={1440} className=' borda form-control text-center ' ></input>
                        
                    </div>

                    <div className='w-25 col-1 text-center '>
                        <h6> Rebaixamento (metros)</h6>
                       
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento1(e.target.value)} value={rebaixamento1} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento2(e.target.value)} value={rebaixamento2} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento3(e.target.value)} value={rebaixamento3} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento4(e.target.value)} value={rebaixamento4} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento5(e.target.value)} value={rebaixamento5} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento6(e.target.value)} value={rebaixamento6} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento7(e.target.value)} value={rebaixamento7} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento8(e.target.value)} value={rebaixamento8} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento9(e.target.value)} value={rebaixamento9} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento10(e.target.value)} value={rebaixamento10} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento11(e.target.value)} value={rebaixamento11} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento12(e.target.value)} value={rebaixamento12} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento13(e.target.value)} value={rebaixamento13} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento14(e.target.value)} value={rebaixamento14} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento15(e.target.value)} value={rebaixamento15} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento16(e.target.value)} value={rebaixamento16} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento17(e.target.value)} value={rebaixamento17} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento18(e.target.value)} value={rebaixamento18} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento19(e.target.value)} value={rebaixamento19} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento20(e.target.value)} value={rebaixamento20} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento21(e.target.value)} value={rebaixamento21} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento22(e.target.value)} value={rebaixamento22} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento23(e.target.value)} value={rebaixamento23} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento24(e.target.value)} value={rebaixamento24} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento25(e.target.value)} value={rebaixamento25} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento26(e.target.value)} value={rebaixamento26} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento27(e.target.value)} value={rebaixamento27} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento28(e.target.value)} value={rebaixamento28} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento29(e.target.value)} value={rebaixamento29} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento30(e.target.value)} value={rebaixamento30} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento31(e.target.value)} value={rebaixamento31} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento32(e.target.value)} value={rebaixamento32} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento33(e.target.value)} value={rebaixamento33} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento34(e.target.value)} value={rebaixamento34} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento35(e.target.value)} value={rebaixamento35} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento36(e.target.value)} value={rebaixamento36} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento37(e.target.value)} value={rebaixamento37} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento38(e.target.value)} value={rebaixamento38} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento39(e.target.value)} value={rebaixamento39} className=' borda form-control text-center ' ></input>
                        <input disabled={bloqueado} onChange={(e) => setRebaixamento40(e.target.value)} value={rebaixamento40} className=' borda form-control text-center ' ></input>
                       
                    </div>

                </div>

            </div>
        </body>


        <div class="row d-flex align-items-end justify-content-end p-1 mt-3 ">
            <div class="col-4">
                <button
                    onClick={() => add()} class="botaoadicionar " >Salvar</button>
            </div>
        </div>

        <br /><br /><br />







    </body>

};